import React from "react";
import { Card, CardBody } from "reactstrap";
import TradeAccordion from "../../components/Trades/TradeAccordion";
import "../../components/Trades/TradeModals.css";

const PlayerProfileTradeTab = ({
  profile,
  box,
  inventory,
  giftPokemonList,
  giftItemList,
  currency,
  showPopupMessage,
}) => {
  return (
    <Card className="profile-trade-card">
      <CardBody className="profile-trade-card__body">
        <TradeAccordion
          profile={profile} // Viewing profile user
          profilePokemon={box} // Their Pokémon
          profileItems={inventory} // Their Items
          myItems={giftItemList} // Your Items (same as in Send Gift)
          myCurrency={currency} // Your Currency (from Send Gift)
          showPopupMessage={showPopupMessage}
        />
      </CardBody>
    </Card>
  );
};

export default PlayerProfileTradeTab;
